// extracted by mini-css-extract-plugin
module.exports = {"regulations":"footer-module--regulations--2Sppv","socialmedias":"footer-module--socialmedias--1el7d","socialmedium":"footer-module--socialmedium--1wYQq"};